module.exports = "/_next/static/images/33b8481db7c744de7a09c11f7299c235-fees-left.jpg.webp";